module.exports = __webpack_public_path__ + "static/media/Logo.61974559.png";